import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  save: {
    id: 'inviteuser.save',
    nb: 'Opprett bruker',
    en: 'Create user',
  },
  cancel: {
    id: 'inviteuser.cancel',
    nb: 'Avbryt',
    en: 'Cancel',
  },
  title: {
    id: 'inviteuser.title',
    nb: 'Opprett ny bruker',
    en: 'Create new user',
  },
  subtitle: {
    id: 'inviteuser.subtitle',
    nb: 'Fyll ut skjemaet under for å invitere ny kollega til Arbeidslivsportalen.',
    en: 'Fill out the form below to invite new colleague to Arbeidslivsportalen.',
  },
  userTitle: {
    id: 'inviteuser.user.title',
    nb: 'Brukerinformasjon',
    en: 'User information',
  },
  userSubtitle: {
    id: 'inviteuser.user.subtitle',
    nb: 'Søk opp kollegaen du vil legge til i Arbeidslivsportalen',
    en: 'Find the colleague you want to add to Arbeidslivsportalen',
  },
  roleTitle: {
    id: 'inviteuser.role.title',
    nb: 'Roller og tilgangsnivå',
    en: 'Roles and access levels',
  },
  roleSubtitle: {
    id: 'inviteuser.role.subtitle',
    nb: 'Velg rolle og tilgangsnivå for brukeren',
    en: 'Select the role and level of access for the user',
  },
  rolePermission: {
    id: 'inviteuser.role.permission',
    nb: 'Rettighet',
    en: 'Permission',
  },
  roleChoose: {
    id: 'inviteuser.role.choose',
    nb: 'Velg rettighetsnivå',
    en: 'Choose permission degree',
  },
  rolleAdministrator: {
    id: 'inviteuser.rolleAdministrator',
    nb: 'Administrator',
    en: 'Administrator',
  },
  rolleRegistrererettighet: {
    id: 'inviteuser.rolleRegistrererettighet',
    nb: 'Registrererettighet',
    en: 'Registrererettighet',
  },
  rolleSkriverettighet: {
    id: 'inviteuser.rolleSkriverettighet',
    nb: 'Skriverettighet',
    en: 'Write access',
  },
  rolleLeserettighet: {
    id: 'inviteuser.rolleLeserettighet',
    nb: 'Leserettighet',
    en: 'Read access',
  },
  success: {
    //TODO: wajid for finskriving
    id: 'inviteuser.success',
    nb: 'Ny bruker opprettet',
    en: 'User created',
  },
  error: {
    //TODO: wajid for finskriving
    id: 'inviteuser.error',
    nb: 'Det skjedde en feil ved oppretting av ny bruker',
    en: 'We experienced an error',
  },
  fsError: {
    id: 'inviteuser.fsError',
    nb: 'Fikk ikke kontakt med FS',
    en: 'Cannot connect to FS',
  },
  fagpersonLabel: {
    id: 'inviteuser.fagpersonLabel',
    nb: 'Fagpersoner',
    en: 'Persons from institution',
  },
  fagpersonPlaceholder: {
    id: 'inviteuser.fagpersonPlaceholder',
    nb: 'Finn person',
    en: 'Find person',
  },
  tilgangLabel: {
    id: 'inviteuser.tilgangLabel',
    nb: 'Tilgangsnivå',
    en: 'Access level',
  },
  tilgangPlaceholder: {
    id: 'inviteuser.tilgangPlaceholder',
    nb: 'Velg ønsket tilgangsnivå for brukeren',
    en: 'Specify an access level for the user',
  },
};

export default translations;
